<div class="projects-header-filter row">
  <!-- ADD PROJECT BUTTON -->
  <div class="col-md-4">
    <button (click)="addProject()" *ngIf="onMyLastProjectsTab" class="btn btn-smart btn-gray" translate>
      <span class="se-icons">new_project</span>T_ADD_PROJECT
    </button>
  </div>

  <!-- FILTER BUTTON -->
  <div *ngIf="hasProjectLength" class="col-md-4">
    <div class="btn-group-filter">
      <!--owned or last modified projects-->
      <span class="button-span" container="body" tooltip="{{getCountProjects(STATUS_OWNED)}}">
                <label (click)="updateStatusFilter()" [(ngModel)]="statusFilters.owned"
                       [ngClass]="{'disabled': disableFilters.owned && !statusFilters.owned,
                       'selected':statusFilters.owned}"
                       btnCheckbox class="btn btn-toggle-white-background " role="button" tabindex="0"
                       translate>T_owned</label>
      </span>
      <span class="button-span" container="body" tooltip="{{getCountProjects(STATUS_CONFIGURED)}}">
        <label (click)="updateStatusFilter()" [(ngModel)]="statusFilters.configured"
               [ngClass]="{'disabled': disableFilters.configured && !statusFilters.configured,
                'selected': statusFilters.configured}"
               btnCheckbox class="btn btn-toggle-white-background" role="button" tabindex="0"
               translate>T_configured</label>
      </span>
      <span class="button-span" container="body" tooltip="{{getCountProjects(STATUS_ORDERED)}}">
                <label (click)="updateStatusFilter()" [(ngModel)]="statusFilters.ordered"
                       [ngClass]="{'disabled': disableFilters.ordered && !statusFilters.ordered,
                        'selected':statusFilters.ordered}"
                       btnCheckbox class="btn btn-toggle-white-background " role="button" tabindex="0"
                       translate>T_ordered</label>
      </span>
      <!-- CPQ user -->
      <span *ngIf="rightService.isCPQUser()" class="button-span" container="body" tooltip="{{getCountProjects(CPQ_PROJECTS)}}">
              <label (click)="switchCpqFilter('ALL');" [(ngModel)]="statusFilters.cpqProjects"
                     [ngClass]="{'disabled': disableFilters.cpqProjects && !statusFilters.cpqProjects,
                      'selected':statusFilters.cpqProjects}"
                     btnCheckbox class="btn btn-toggle-white-background " role="button" tabindex="0"
                     translate>T_CPQ_PROJECTS</label>
      </span>
      <span *ngIf="rightService.isCPQUser()" class="button-span" container="body" tooltip="{{getCountProjects(CPQ_PROJECTS_WITH_DEFAULT_QUOTE_ID)}}">
              <label (click)="switchCpqFilter('QUOTE_ID')" [(ngModel)]="statusFilters.cpqProjectsWithDefaultQuoteId"
                     [ngClass]="{'disabled': disableFilters.cpqProjectsWithDefaultQuoteId && !statusFilters.cpqProjectsWithDefaultQuoteId,
                      'selected':statusFilters.cpqProjectsWithDefaultQuoteId}"
                     btnCheckbox class="btn btn-toggle-white-background " role="button" tabindex="0"
                     translate>T_CPQ_PROJECTS_WITH_DEFAULT_QUOTE_ID</label>
      </span>
    </div>
  </div>

  <!-- SEARCH FIELD -->
  <div *ngIf="hasProjectLength" class="col-md-4 btn-group-filter">
    <input (keyup)="updateProjectsList()"
           [(ngModel)]="nameFilterContent"
           class="search-input-text"
           pInputText
           placeholder="{{'T_PROJECT_SEARCH_TITLE' | translate}}"
           size="50"
           type="text">
    <em class="fa fa-search search-icon"></em>
  </div>
</div>

<div *ngIf="hasNoProject">
  <h3 class="page-title" translate>T_PROJECT_NO_PROJECT</h3>
</div>

<div>
  <h6 *ngIf="resultFiltredProjects?.length > 1" class="page-subtitle">
    {{resultFiltredProjects.length}}
    <span translate>T_PROJECTS</span></h6>
  <h6 *ngIf="resultFiltredProjects?.length === 1" class="page-subtitle" translate>
    {{resultFiltredProjects.length}}
    <span translate>T_PROJECT</span></h6>
</div>
